<template>
  <div>

    <!-- section 1 -->
    <div class="landing-cnt-prof row">
      <div style="max-height: 100vh;" class="landing-child bg-img p-0 p-lg-5">
      </div>
      <div class="landing-child container-title-padding text-block-ctn">
        <div class="main-block-professional col">
          <h1>{{ $t('main-professional-block-h1') }}</h1>
          <h3>{{ $t('main-professional-block-h4') }}</h3>
          <h4 class="d-mobile-rotated-none">{{ $t('main-professional-block-h2') }}</h4>
          <div class="btn-cnt">
            <router-link v-if="!$uiHelpers.isMobile" to="/contacto"><base-button class="btn-landing" white style="color:#3238C4;z-index:1001;position:relative">{{ $t('prove-free') }}</base-button></router-link>
            <router-link v-if="$uiHelpers.isMobile" to="/inicio-sesion"><base-button class="btn-landing" white style="color:#3238C4;z-index:-1;position:relative">{{ $t('access') }}</base-button></router-link>
              <router-link to="/pacientes"><base-button class="btn-landing-pat" style="border-color:#4A4A4A;border:1.5px solid #4A4A4A;z-index:-1;;position:relative; color:#4a4a4a !important" outline>{{ $t('access-patient') }}</base-button></router-link>             
            </div>
        </div>
      </div>
      </div>
      <neu-cards-slider2 cols=3 class="py-lg-5 py-0 mt-0 mt-md-5 position-relative" :cards="cards" :blackTitle="$t('block-2.blackTitle')" :title="$t('block-2.title')"></neu-cards-slider2>
        <router-link to="/registro-profesional">
        <base-button class="btn mx-auto d-block mb-5" blue outline><span>{{ $t('registerfor-free') }}</span></base-button>
        </router-link>

        <!-- section 5 -->
        <b-row id="security-data" class="section-invert reverse-sm">
        <b-col md="12" lg="6">
          <div class="col-bg ml-lg-auto">
          </div>
        </b-col>
        <b-col md="12" lg="6" class="content my-auto">
           <h3>{{ $t('block-5.blackTitle') }}</h3>
           <div class="subtitle" style="margin-bottom:7rem;">
            <p>{{ $t('block-5.text2') }}</p>
          </div>
              <b-row style="display:initial;" class="cert-icons">
         <div style="display:inline-block">
        <ISO27001Logo/>
      </div>
       <!-- <div style="display:inline-block">
        <a href="https://www.cgcom.es/plataformas_receta_homologadas/sist-prescripcion/openhealthcare"></a>
        <img class="vertical" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png"/>
      </div> -->
          </b-row>
         </b-col>
      </b-row>     
      
      <!-- section 4 -->
       <b-row id="incomes-aument" class="section-white-list">
      <!-- <div class="bg-heart"></div> -->
      <!-- <div class="bg-image" v-if="!$store.state.git s"></div> -->
        <b-col md="12" lg="6" class="content my-auto">
          <div>
            <h3>{{ $t('block-4.blackTitle') }}</h3><h5>{{ $t('block-4.title') }}</h5>
          </div>
          <div class="subtitle">
            <div class="subtitle-list subtitle-list-large">
              <b-row v-for="(item, index) in [$t('block-4.text'), $t('block-4.text2'), $t('block-4.text3'), $t('block-4.text4')]" :key="index">
                <b-col class="tick-mobile" cols="2" md="1">
                  <p><rounded-check-icon/></p>
                </b-col>
                <b-col cols="10">
                  <span>
                    {{ item }}
                  </span>
                </b-col>
              </b-row>
              
              <b-row class="mt-5">
                <router-link to="/contacto">
                <base-button class="btn-more-info" blue outline><span style="font-size:1rem">{{ $t('more-information-btn') }}</span></base-button>
                </router-link>
              </b-row>
            </div>
          </div>
        </b-col>
         <b-col md="12" lg="6" class="py-sm-0 py-lg-5 pl-lg-5 pr-lg-5">
      <div class="col-bg ml-lg-auto"> 
      </div>
    </b-col>
      </b-row>

   <!-- section 3 -->
<b-row id="offer-service" class="section-invert reverse-sm">
  <b-col class="no-mobile" md="12" lg="6">    
    <div class="container-hearth">
      <div>
        <div class="bg-heart-2"></div>
                    <h6 style="position:absolute" class="centered-title">{{ $t('ask-for-demo-title') }}</h6>
                    <router-link to="/contacto">
          <base-button  class="btn centered-button my-auto" style="margin-bottom:10rem; z-index: 50;position:absolute;left:49.5%" blue outline><span>{{  $t('ask-for-demo') }}</span></base-button>
                    </router-link>
     <!-- <base-button class="centered-button" white @click="() => { signInVisible = true }"><span style="color: #3238C4;font-weight:bold">{{ $t('ask-for-demo') }}</span></base-button> -->
      </div>
    </div>
        </b-col>
        <b-col md="12" lg="6" class="content my-auto">
          <div style="display: inline-block;">
            <h3>{{ $t('block-3.blackTitle') }}</h3><h5>{{ $t('block-3.title') }}</h5>
          </div>
          <div class="subtitle">
            <p>{{ $t('block-3.text') }}</p>
          </div>
           <div class="subtitle">
            <p>{{ $t('block-3.text2') }}</p>
          </div>
          <div class="subtitle">
            <p>{{ $t('block-3.text3') }}</p>
          </div>
        </b-col>
        
      </b-row>

      <!-- section 6 -->
        <neu-cards-slider-pricing-professionals v-if="!inMx" class="section" :white="true" :cards="cardsPricing" :cards2="cardsPricing2" :cards3="cardsPricingComission" :title="$t('block-8.title')" :iva="$t('block-8.iva')"></neu-cards-slider-pricing-professionals>

 <!-- section 7 -->
       <b-row id="opensalud4all" class="section-black-list reverse-sm" v-if="!inMx">
        <b-col md="12" lg="6" class="content my-auto">
          <div class="d-inline-block">
            <h3>{{ $t('block-7.blackTitle') }}</h3>
          </div>
          <div class="subtitle" style="font-weight: bold;">
            <div class="subtitle-list subtitle-list-large mt-sm-3">
              <b-row class="mb-3">
                <b-col cols="12">
                  <span style="display:inline-block">
                   <p style="color:white;display:inline-block;">opensalud4all</p> {{ $t('block-7.text1') }}
                   <br><br>
                   {{ $t('block-7.text2') }}
                   <br><br>
                   {{ $t('block-7.text3') }}
                  </span>
                </b-col>
              </b-row>
            </div>
          </div>
          <base-button @click="goToOpensalud4allLanding" style="color:white" class="btn-more-info-white mt-5" white outline><span style="color:white">{{ $t('more-information-btn') }}</span></base-button>
          </b-col>
        <b-col md="12" lg="6">
          <div class="col-bg ml-lg-auto">
          </div>
        </b-col>
      </b-row>
    </div>
</template>

<script>
import NeuCardsSlider2 from '@/components/base/ui/NeuCardsSlider2.vue'
import NeuCardsSliderPricingProfessionals from '@/components/base/ui/NeuCardsSliderPricingProfessionals.vue'
import RoundedCheckIcon from '@/components/base/icons/RoundedCheckIcon.vue'
import layoutMixin from '@/mixins/layout.mixin'
import ISO27001Logo from '@/components/utils/ISO27001Logo.vue'
import { inMx } from '@/helpers/global.helpers'

export default {
  name: 'landing-professional-menu',
  mixins: [layoutMixin],
  components: {
		NeuCardsSlider2,
		NeuCardsSliderPricingProfessionals,
		RoundedCheckIcon,
		ISO27001Logo
  },
  data () {
    return {
			inMx,
      cards: [
        {
          title: this.$t('card.title-video'),
          subtitle: this.$t('card.subtitle-video'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_VIDEOCONSULTA_AZUL.svg',
          type: 0,
          es: true,
          mx: true
        },
        {
          title: this.$t('card.title1'),
          subtitle: this.$t('card.subtitle1'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/online-consultation.svg',
          type: 0,
          es: true,
          mx: true
        },
/*         {
          title: this.$t('card.title2'),
          subtitle: this.$t('card.subtitle2'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png',
          type: 0
        }, */
        {
          title: this.$t('card.title3'),
          subtitle: this.$t('card.subtitle3'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_HISTORIAL_CLINICO.svg',
          type: 0,
          es: true,
          mx: true
        },
        {
          title: this.$t('card.title4'),
          subtitle: this.$t('card.subtitle4'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_CONSULTA_CASA.svg',
          type: 0,
          es: true,
          mx: true
        },
        {
          title: this.$t('card.title5'),
          subtitle: this.$t('card.subtitle5'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_PACKS.svg',
          type: 0,
          es: true,
          mx: false
        },
        {
          title: this.$t('card.title6'),
          subtitle: this.$t('card.subtitle6'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_CALENDARIO.svg',
          type: 0,
          es: true,
          mx: true
        },
        {
          title: this.$t('card.title7'),
          subtitle: this.$t('card.subtitle7'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_OPENSALUD_PASS.svg',
          type: 0,
          es: true,
          mx: true
        },
         {
          title: this.$t('card.title8'),
          subtitle: this.$t('card.subtitle8'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/ICN_OUT_TELE_MONITORIZACIÓN.svg',
          type: 0,
          es: true,
          mx: true
        },
         {
          title: this.$t('card.title9'),
          subtitle: this.$t('card.subtitle9'),
          src: this.$t('card.src-price'),
          type: 0,
          es: true,
          mx: true
        },
        {
          title: this.$t('card.title10'),
          subtitle: this.$t('card.subtitle10'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/neu/interconsultations.svg',
          type: 0,
          es: true,
          mx: true
        }
      ],
      cardsPricing: [
        {
          title: this.$t('cardsPricing.title1'),
          priceTitle: '9,90€',
          subtitle: this.$t('cardsPricing.electronicrecipe'),
          priceSubtitle: '5,90€'
        }
      ],
      cardsPricing2: [
        {
          title: this.$t('cardsPricing.title2'),
          priceTitle: '29€',
          text: this.$t('cardsPricing.text2')
        }
      ],
      cardsPricingComission: [
        {
          title: this.$t('cardsPricing.subtitle'),
          subtitle: this.$t('cardsPricing.subtitle1'),
          subtitle3: this.$t('cardsPricing.subtitle3')
        }
      ]
    }
  },
  methods: {
    goToOpensalud4allLanding () {
      window.location = 'https://opensalud4all.com/'
    }
  }
}
</script>

<style lang="scss" scoped>
    @import "static-appopensalud/css/public/views/opensalud_profesionales.scss";
  /deep/ {
    .btn-min-height{
      @include desktop{
       min-height: 27rem !important;
      }
      @include desktop-sm{
       min-height: 27rem !important;
      }
    }
    .neu-card-general-ctn {
      @include mobile {

        padding-left: 2rem;
        padding-right: 2rem;
      }
    }
    .neu-card-general{
      background-color: #eee;

    @include mobile {
        min-height: 300px;
        margin-right: 2%;
        -webkit-transition: all .5s ease;
        transition: all .5s ease;
        text-align: center;
        margin-top: auto;
        padding: 1rem;
        margin-bottom: 2rem;
    }
    @include tablets {
        min-height: 300px;
        margin-right: 2%;
        -webkit-transition: all .5s ease;
        transition: all .5s ease;
        text-align: center;
        margin-top: auto;
        padding: 1rem;
        margin-bottom: 2rem;
    }
    }
    .neu-card-general:hover {
    border: 2px solid #3238C4;
}
  }
  /deep/ { .lang-cnt {
    color: $blue;
    font-weight: bold;
    transition: all 0.3s ease;

    span {
      cursor: pointer;
      /* vertical-align: sub; */
      &:not(:last-child) {
        margin-right: 1rem;
      }
      

      &:hover {
        transition: all 0.3s ease;
        border-top: 1px solid $blue#{55};
        @include mobile {
          border-top: 2px solid white#{55} !important;
        }
      }

      &.active {
        border-top: 2px solid $blue;
      }
    }
  }
}
  @include mobile {
  /deep/ .navbar {
    // padding: 0rem 2rem;
     padding-left: 0rem !important;
  }
}
  .opensalud-theme {
  p {
    @include desktop {
      margin-bottom: 0 !important;
      margin-top: 0 !important;
    }
  }
}
  .access-btn{
    @include media(tablets, mobile) {
    color: #3238C4 !important;
    background-color: transparent !important;    
    }
  }
 
  .tick-mobile {
    // @include mobile {
    //   margin-right:1.25rem;
    // }
    // @include tablets {
    //   margin-right:1.25rem !important;
    // }
    // @include desktop-sm {
    //   margin-right:1.25rem !important;
    // }
     @include desktop {
      margin-right: 1rem;
      // margin-right:1.25rem !important;
      bottom:0.5rem !important;
    }
  }
   .btn-more-info {
  //     @media screen and (min-width: 200px) and (max-width: 425px) {
  //     margin-left: 5rem !important;
  //   }
  //    @media screen and (min-width: 426px) and (max-width: 1024px) {
  //     margin-left: 4rem !important;
  //   }
  //   @media screen and (min-width: 1025px) and (max-width: 1440px) {
  //     margin-left: 9rem !important;
  //   }
  // @media screen and (min-width: 1441px) {
  //     margin-left: 10rem !important;
  //   }
    span {
        color: $blue !important;font-weight:bold; border-color:white;font-size:1rem;
      }
  }
  .btn-more-info:hover{
    color: #eee;
    background-color: $blue;
    border-color: $blue;
    span {
      color: white !important;
    }
  }
  .btn-more-info-white {
    span {
        color: white !important;font-weight:bold; border-color:white;font-size:1rem;
      }
  }
   .btn-more-info-white:hover{
    color: #eee;
    background-color: $blue;
    border-color: $blue;
    span {
      color: #1D1D1E !important;
    }
  }
  .nav-item {
    @include desktop {
      margin-right: 1rem;
    }

    @include tablets {
      padding: 2rem;
      font-size:20px;
    }

    @include mobile {
      padding: 0rem 2rem;
    }
  }
  .menu-cnt {
    font-weight: bold;

    p {
          color: $blue;
         
           @include desktop {
       &:is(:last-child) {
        margin-right: 1rem;
      }&:is(:first-child) {
        margin-left: 1rem;
      }
        }
          @include mobile {
       padding: 0;
        }
    }
  }
  .no-mobile{
    align-self: center;
     @include media(mobile, tablets) {
      display: none;
    }
  }
  .container-hearth {
    background-color:#E4E4E4;
    position: relative;
     @include desktop {
       left: 3%;
      text-align: center;
      color: white;
        }
   @include media(mobile, tablets) {
      display: none;
    }
}
  .centered-title {
     @include desktop {
        position: absolute;
        top: 45%;
        font-size:3rem;
        left: 50%;
         @media screen and (max-width: 1440px) {
        font-size:3rem !important;

    }
        transform: translate(-50%, -50%);
        }
        @include desktop-sm {
        position: absolute;
        top: 45%;
        font-size:2rem !important;
        left: 50%;
        transform: translate(-50%, -50%);
        }
        @include media(mobile, tablets) {
      display: none;
    }

}
  .centered-button {
    @include desktop {
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
        }
        @include media(mobile, tablets) {
      display: none;
    }

}
    .btn:hover {
        cursor: pointer;
    }
    .btn:focus{
        outline:none;
    }

</style>


// WEBPACK FOOTER //
// src/components/views/opensalud/Profesionales.vue